import React, { FC, useState, Fragment, useEffect, useCallback } from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { setParameter } from '../../actions/setParam';
import { sortedCollection } from '../../selectors';

import isAuthenticated from '../../components/Authentication/Authenticated';

import classes from './Robots.module.css';
import classNames from 'classnames';

import Messages from './Robots.messages';
// import PopoverBox from '../PopoverBox/PopoverBox';
import RobotEdit from '../../components/RobotEdit/RobotEdit';
import { AppRootState, useTypedSelector } from '../../reducers';
import RobotsOptions from './RobotsOptions';
import RobotsList from './RobotsList';
import { equalityFnc, getDevices } from '../../utils/conformState';
import { Device } from '../../types/types';
import { store } from '../../store/store';

const headers = [
	{ title: Messages.group, property: 'deviceGroupName' },
	{ title: Messages.location, property: 'location' },
	{ title: Messages.status, property: 'currentState' },
	{ title: Messages.charge, property: 'level' },
	{ title: Messages.serialNumber, property: 'deviceId' },
];

interface RobotsProps {
	filterValues: any;
	orgId: string;
	editableRobotId?: any;
	history: any;
}

const Robots: FC<RobotsProps> = (props: any) => {
	const { intl, organization, editableRobotId, history, filterValues } = props;

	const orgId = organization.orgId;
	const organizationName = organization.name;
	const selectedOrganizationType = organization.orgType;
	const deviceGroups = useTypedSelector(
		state => state.deviceGroupsState.deviceGroupsByOrganizationId,
		(left, right) => equalityFnc(left, right)
	);
	const devices = useTypedSelector(
		state => getDevices(state, orgId, 'tableInfo'),
		(left, right) => equalityFnc(left, right)
	);
	const sortParams = useTypedSelector(
		state => state.deviceState.sortParams,
		(left, right) => equalityFnc(left, right)
	);

	const [isEditing, setIsEditing] = useState(false);
	const [isAddNewRobotShow, setAddNewRobotShow] = useState(false);
	const [deviceToShow, setDeviceToShow] = useState([]);
	const [prevFilterToShow, setPrevFilterToShow] = useState([]); // here set filter data
	const [selectedDeviceId, setSelectedDeviceId] = useState<string | undefined>(undefined);
	const [searchText, setSearchText] = useState('');
	const [resetSearchData, setResetSearchData] = useState(false);
	const [deviceGroupNames, setDeviceGroupNames] = useState<string[]>([]);
	const [filterValue, setFilterValue] = useState<string>('all');

	const [selectRobots, setSelectRobots] = useState(false);
	const [selectedRobots, updateSelectedRobots] = useState<any[]>([]);

	const spinoutType = useTypedSelector(state => state.versionState.spinoutType);
	const mongoDevices = useTypedSelector(state => state.deviceState.mongoDevices);

	const hasChildOrgs = organization.childOrgs
		? Object.keys(organization.childOrgs).length !== 0
			? true
			: false
		: false;

	const headers =
		spinoutType !== 'uvd'
			? [
					{
						title: Messages.name,
						property: 'name',
						checkbox: selectRobots,
						onUnCheck: () => {
							setSelectRobots(false);
							unCheckAll();
						},
						selectedNumber: selectedRobots.length,
					},
					{ title: Messages.group, property: 'deviceGroupName' },
					{ title: Messages.location, property: 'location' },
					{ title: Messages.status, property: 'currentState' },
					{ title: Messages.charge, property: 'level' },
					{ title: Messages.serialNumber, property: 'deviceId' },
			  ]
			: [
					{
						title: Messages.name,
						property: 'name',
						checkbox: selectRobots,
						onUnCheck: () => {
							setSelectRobots(false);
							unCheckAll();
						},
						selectedNumber: selectedRobots.length,
					},
					{ title: Messages.battery, property: 'battery' },
					{ title: Messages.status, property: 'currentState' },
					{ title: Messages.disinfections, property: 'disinfections' },
					{ title: Messages.inUseSince, property: 'inUseSince' },
			  ];

	const handleOnCheck = (robot: any, bool: boolean) => {
		if (bool) {
			let obj = selectedRobots.find(o => o.deviceId === robot.deviceId);
			if (!obj) updateSelectedRobots(selectedRobots.concat(robot));
		} else {
			updateSelectedRobots(
				selectedRobots.filter((item: any) => item.deviceId !== robot.deviceId)
			);
		}
	};
	const checkAll = (data: any) => {
		updateSelectedRobots(data);
	};
	const unCheckAll = () => {
		updateSelectedRobots([]);
	};

	useEffect(() => {
		if (!editableRobotId) return;
		setSelectedDeviceId(editableRobotId);
		setIsEditing(true);
	}, [editableRobotId]);

	useEffect(() => {
		let arr: Array<any> = [];
		arr = devices || [];
		if (filterValue) {
			arr = prevFilterToShow;
		}
		if (searchText) {
			arr = arr.filter((r: any) => {
				return (
					r.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
					r.deviceId.indexOf(searchText.toLowerCase()) > -1
				);
			});
		}
		let collection: any = sortedCollection({
			items: arr ? arr : [],
			sortParams: sortParams,
		});
		setDeviceToShow(collection);
		setResetSearchData(false);
	}, [devices, searchText, selectedOrganizationType, sortParams, resetSearchData]);

	useEffect(() => {
		if (!deviceGroups[orgId]) return;

		let names: any = Object.values(deviceGroups[orgId]).map(
			(deviceGroup: any) => deviceGroup.name
		);
		const filteredNames = names.filter((name: string) => name !== 'Unassigned');
		//filterValues.splice(1, 0, filteredNames); Add this once stability is reached
		setDeviceGroupNames(names);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [deviceGroups, filterValues, orgId]);

	useEffect(() => {
		if (filterValue === undefined) return;
		let all: any = devices || [];

		// DO NOT REMOVE THIS! robot was passed by ref and not value
		all = JSON.parse(JSON.stringify(all));

		if (spinoutType === 'uvd') {
			all = all.map((device: any) => {
				return { ...device, mongoDevice: mongoDevices[device.deviceId] };
			});
		}

		const devicesInfo = JSON.parse(
			JSON.stringify(
				(store.getState() as AppRootState).deviceState.devicesByOrganizationId[orgId] || {}
			)
		);
		const deviceIdKeys = Object.keys(devicesInfo);

		switch (filterValue) {
			case 'all':
				setDeviceToShow(all);
				setPrevFilterToShow(all);
				if (searchText) {
					setResetSearchData(true);
				}
				break;
			case 'available':
				let available: any = all.filter((item: any) => {
					if (!deviceIdKeys.includes(item.deviceId)) return null;
					let statusObj = JSON.parse(devicesInfo[item.deviceId]?.status);
					let status = devicesInfo[item.deviceId]?.currentState
						? devicesInfo[item.deviceId].currentState
						: statusObj?.currentState
						? statusObj.currentState
						: null;
					let online = devicesInfo[item.deviceId]?.online
						? devicesInfo[item.deviceId].online
						: statusObj?.online
						? statusObj.online
						: null;
					if (status === 'available' && online) {
						return item;
					}
					return null;
				});
				setDeviceToShow(available);
				setPrevFilterToShow(available);
				if (searchText) {
					setResetSearchData(true);
				}
				break;
			case 'unavailable':
				let unavailable: any = all.filter((item: any) => {
					if (!deviceIdKeys.includes(item.deviceId)) return null;
					let statusObj = JSON.parse(devicesInfo[item.deviceId]?.status);
					let status = devicesInfo[item.deviceId]?.currentState
						? devicesInfo[item.deviceId].currentState
						: statusObj?.currentState
						? statusObj.currentState
						: null;

					if (status !== 'available') return item;
					return null;
				});
				setPrevFilterToShow(unavailable);
				setDeviceToShow(unavailable);
				if (searchText) {
					setResetSearchData(true);
				}
				break;
			case 'unassigned':
				let unassigned: any = all.filter((item: Device) => {
					if (!deviceIdKeys.includes(item.deviceId)) return null;
					if (
						devicesInfo[item.deviceId].deviceGroupsIds?.length === 0 ||
						devicesInfo[item.deviceId].deviceGroupsIds == null
					) {
						return item;
					}
					return null;
				});
				setPrevFilterToShow(unassigned);
				setDeviceToShow(unassigned);
				if (searchText) {
					setResetSearchData(true);
				}
				break;
			default:
				if (deviceGroupNames.findIndex((name: any) => name === filterValue) > -1) {
					let byGroup: any = all.filter((item: any) => {
						if (!deviceIdKeys.includes(item.deviceId)) return null;
						const deviceGroupId = devicesInfo[item.deviceId].deviceGroupsIds
							? devicesInfo[item.deviceId].deviceGroupsIds[0]
							: null;
						if (
							deviceGroups[orgId][deviceGroupId] &&
							deviceGroups[orgId][deviceGroupId].name === filterValue
						)
							return item;
						return null;
					});
					setDeviceToShow(byGroup);
					if (searchText) {
						setResetSearchData(true);
					}
				}
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterValue, mongoDevices, devices]);

	useEffect(() => {
		if (history.location.data?.editableRobot) {
			const robot = history.location.data.editableRobot;
			setSelectedDeviceId(JSON.parse(JSON.stringify(robot)).deviceId);
			history.location.data.editableRobot = undefined;
		}
	}, [history.location.data]);

	useEffect(() => {
		if (selectedOrganizationType === 'bor') {
			setAddNewRobotShow(true);
		}
	}, [selectedOrganizationType]);

	return !isEditing ? (
		<Fragment>
			<div className={classes.leftSide}>
				<RobotsOptions
					showTransferRobot={devices.length > 0}
					organizationName={organizationName}
					selectedRobots={selectedRobots}
					selectRobots={selectRobots}
					setSelectRobots={setSelectRobots}
					isAddNewRobotShow={isAddNewRobotShow}
					deviceToShow={deviceToShow}
					searchText={searchText}
					setSearchText={setSearchText}
					selectedFilter={filterValue}
					filterValues={filterValues}
					setFilterValue={setFilterValue}
					headers={headers}
					handleOnCheck={selectRobots && handleOnCheck}
					unCheckAll={unCheckAll}
				/>
			</div>
			<div className={classes.rightSide}>
				<RobotsList
					robotHeaders={headers}
					setSelectedDeviceId={setSelectedDeviceId}
					setIsEditing={setIsEditing}
					data={deviceToShow}
					selectRobots={selectRobots}
					selectedRobots={selectedRobots}
					onUnCheck={() => {
						setSelectRobots(false);
						unCheckAll();
					}}
					checkAll={checkAll}
					unCheckAll={unCheckAll}
					handleOnCheck={selectRobots && handleOnCheck}
					check
				/>
			</div>
		</Fragment>
	) : (
		<RobotEdit
			editableDeviceId={selectedDeviceId}
			onClose={() => setIsEditing(false)}
			orgId={orgId}
		/>
	);
};

const mapStateToProps = (state: any) => ({
	organization: state.selectedOrganizationState.organization,
});

const enhance = compose(connect(mapStateToProps, { setParameter }));

export default injectIntl(isAuthenticated(enhance(Robots), 'Robots'));
